<template>
  <div class="detail-container">
    <el-card>
      <!-- 筛选栏保持不变 -->
      <div class="filter-container">
        <el-select v-model="queryState" placeholder="请选择执行状态" style="width: 200px; margin-right: 10px">
          <el-option label="全部" value="" />
          <el-option label="进行中" value="0" />
          <el-option label="执行完成" value="1" />
          <el-option label="已下载" value="3" />
          <el-option label="执行失败" value="2" />
          <el-option label="地址失效" value="4" />
        </el-select>
        <el-date-picker v-model="queryDate" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="YYYY-MM-DD" style="margin-right: 10px; width: 350px" />
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>

      <!-- 核心修改：添加序号列，支持分页全局连续序号 -->
      <el-table :data="recordList" style="width: 100%; margin-top: 20px" border>
        <!-- 序号列：放在第一列，使用自定义计算实现全局连续 -->
        <el-table-column label="序号" width="80" align="center">
          <template #default="{ $index }">
            {{ (pageNum - 1) * pageSize + $index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="task_id" label="任务ID" min-width="180" show-overflow-tooltip />
        <el-table-column prop="workid" label="作品ID" min-width="120" show-overflow-tooltip />
        <el-table-column prop="workod" label="镜号" width="80" />
        <el-table-column prop="energy" label="能量值" width="80" />
        <el-table-column prop="status" label="任务状态" width="120">
          <template #default="{ row }">
            <el-tag :type="getStatusTagType(row.status)">
              {{ getStatusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="下载地址" min-width="280" show-overflow-tooltip>
          <template #default="{ row }">
            <div class="download-address-wrapper" style="display: flex; align-items: center; gap: 8px;">
              <span class="address-text"
                style="flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ row.dowurl ? row.dowurl : "无地址或客户端截取" }}
              </span>
              <el-button v-if="row.dowurl" size="small" type="text" style="color: #409eff; padding: 4px 8px;"
                @click.stop="copyToClipboard(row.dowurl)">
                复制
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="error" label="错误原因" min-width="200" show-overflow-tooltip />
        <el-table-column prop="CreationTime" label="创建时间" min-width="160" />
      </el-table>

      <!-- 分页组件保持不变 -->
      <div class="pagination-container" style="margin-top: 20px; text-align: right">
        <el-pagination v-model:current-page="pageNum" v-model:page-size="pageSize" :total="total" background
          layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
      <!-- 展示能量总额 -->
      <div class="energy-summary-all" style="padding: 10px; background: #f5f7fa; margin-bottom: 10px;">
        <div v-for="(item, key) in statusEnergyTotal" :key="key" style="display: inline-block; margin-right: 15px;">
          {{ item.text }}：{{ item.energyTotal }}（{{ item.recordCount }}条）
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
// 其余代码完全不变，无需修改
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import { ElMessage } from "element-plus";

const router = useRouter();
const route = useRoute();

const promoter = ref("");
const date = ref("");
const amount = ref("");
const number = ref("");
const divide = ref("");

const queryState = ref("");
const queryDate = ref([]);
const recordList = ref([]);

const pageNum = ref(1);
const pageSize = ref(15);
const total = ref(0);
const statusEnergyTotal = ref({}); // 定义响应式变量接收状态能量总额

const statusMap = ref({
  "0": { text: "进行中", type: "warning" },
  "1": { text: "执行成功", type: "primary" },
  "2": { text: "执行失败", type: "danger" },
  "3": { text: "已下载", type: "success" },
  "4": { text: "地址失效", type: "info" }
});

const getStatusText = (status) => {
  return statusMap.value[status]?.text || "未知状态";
};

const getStatusTagType = (status) => {
  return statusMap.value[status]?.type || "default";
};

// 核心新增：封装复制到剪贴板工具函数
const copyToClipboard = async (text) => {
  // 边界判断：无有效文本时直接返回
  if (!text || typeof text !== "string") {
    ElMessage.warning("无有效内容可复制");
    return;
  }

  try {
    // 使用浏览器原生 Clipboard API 复制文本
    await navigator.clipboard.writeText(text);
    // 复制成功提示
    ElMessage.success("复制成功！已存入剪贴板");
  } catch (error) {
    console.error("复制失败：", error);
    // 复制失败降级提示（兼容部分不支持 Clipboard API 的浏览器）
    ElMessage.error("复制失败，请手动选中复制");
  }
};

const fetchRecords = async (needEnergySummary = false) => {
  try {
    const dateRange = queryDate.value || []; // 关键：null 转为空数组
    const startTime = dateRange[0] || ""; // 空数组访问 [0] 为 undefined，再转为空字符串
    const endTime = dateRange[1] || "";

    const requestParams = {
      status: queryState.value || undefined,
      startTime: startTime,
      endTime: endTime,
      pageNum: pageNum.value,
      pageSize: pageSize.value,
      withEnergySummary: needEnergySummary
    };

    const res = await axios.post("/admin/queryEnergylog", requestParams);
    if (res.data.msg === "success") {
      console.log("返回数据:", res.data.data);
      const { list, pagination, statusEnergyTotal: backendStatusEnergyTotal } = res.data.data;
      recordList.value = list;
      total.value = pagination.total;
      pageNum.value = pagination.pageNum;
      pageSize.value = pagination.pageSize;
      statusEnergyTotal.value = backendStatusEnergyTotal || statusEnergyTotal.value; // 接收状态能量总额
    }
    ElMessage.success("获取成功");
  } catch (error) {
    console.error("获取能量记录失败:", error);
    ElMessage.error("查询失败，请稍后重试");
  }
};

// 搜索按钮点击（筛选条件变化，需要获取能量总额）
const handleSearch = () => {
  pageNum.value = 1;
  fetchRecords(true);
};

// 改变每页条数
const handleSizeChange = (newSize) => {
  pageSize.value = newSize;
  fetchRecords(); // 传递false（或不传递，默认false），不获取能量总额
};

// 切换页码
const handleCurrentChange = (newPage) => {
  pageNum.value = newPage;
  fetchRecords(); // 不传递参数，默认false，不获取能量总额
};

onMounted(() => {
  const { promoter: p, date: d, amount: a, number: n, divide: div } = route.query;
  promoter.value = p;
  date.value = d;
  amount.value = a;
  number.value = n;
  divide.value = div;
  fetchRecords(true);
});


</script>

<style scoped>
.detail-container {
  padding: 20px;
}

.filter-container {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.el-card__header {
  display: flex;
  align-items: center;
}

.el-card__header span {
  margin-left: 10px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>